import { useUser } from '@nbfc-expense-tool/data-store/auth';
import { checkForSinglePermission } from '@nbfc-expense-tool/data-store/permissions';
import { Button, PlusIcon } from '@nbfc-expense-tool/ui';
import { useNavigate } from 'react-router-dom';

type AddNewButtonProps = {
  label?: string;
  id: string;
};

export const AddNewReimbursementButton: React.FC<AddNewButtonProps> = ({
  label = 'Add New',
  id,
}) => {
  const navigate = useNavigate();
  const { user } = useUser();

  if (
    !checkForSinglePermission(
      'createReimbursement',
      user?.roles[0]?.permissions || null
    )
  ) {
    return null;
  }

  return (
    <Button
      id={`${id}-add-new-reimbursement-button`}
      title={label}
      leftIcon={(props) => <PlusIcon {...props} />}
      onClick={() => {
        navigate('/add-new-reimbursement');
      }}
    />
  );
};
